import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const TopBooksPage = () => {
  const [wishlistBooks, setWishlistBooks] = useState([]);
  const [completedBooks, setCompletedBooks] = useState([]);
  const [timeframe, setTimeframe] = useState("month");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [wishlistRes, completedRes] = await Promise.all([
          axios.get(
            `https://bookmatchup.onrender.com/api/lists/top-wishlist?timeframe=${timeframe}`
          ),
          axios.get(
            `https://bookmatchup.onrender.com/api/lists/top-completed?timeframe=${timeframe}`
          ),
        ]);
        setWishlistBooks(wishlistRes.data.slice(0, 10));
        setCompletedBooks(completedRes.data.slice(0, 10));
      } catch (err) {
        console.error("Error loading top books:", err);
      }
    };
    fetchData();
  }, [timeframe]);

  const renderTable = (title, data, type) => (
    <div style={{ marginBottom: "3rem" }}>
      <h3>{title}</h3>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead style={{ background: "#f4f4f4" }}>
          <tr>
            <th>Count</th>
            <th>Cover</th>
            <th>Title</th>
            <th>Author</th>
          </tr>
        </thead>
        <tbody>
          {data.map(({ bookDetails, count }) => (
            <tr
              key={bookDetails._id}
              style={{ borderBottom: "1px solid #ddd" }}
            >
              <td style={{ textAlign: "center" }}>{count}</td>
              <td style={{ textAlign: "center", padding: "10px" }}>
                {bookDetails.cover_url && (
                  <img
                    src={bookDetails.cover_url}
                    alt="Cover"
                    style={{ maxWidth: "60px" }}
                  />
                )}
              </td>
              <td>
                {bookDetails.itemId ? (
                  <Link
                    to={`/book/${encodeURIComponent(bookDetails.itemId)}`}
                    style={{ color: "#b42a2a" }}
                  >
                    {bookDetails.title}
                  </Link>
                ) : (
                  bookDetails.title
                )}
              </td>
              <td>{bookDetails.author_name?.join(", ") || "Unknown"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div>
      <h2>Top Books ({timeframe || "All Time"})</h2>
      <div style={{ marginBottom: "1.5rem" }}>
        <label>Timeframe: </label>
        <select
          value={timeframe}
          onChange={(e) => setTimeframe(e.target.value)}
        >
          <option value="week">Last Week</option>
          <option value="month">Last Month</option>
          <option value="year">Last Year</option>
          <option value="">All Time</option>
        </select>
      </div>

      {renderTable("📚 Most Wishlisted", wishlistBooks, "wishlist")}
      {renderTable("✅ Most Completed", completedBooks, "completed")}
    </div>
  );
};

export default TopBooksPage;
